import styled from 'styled-components'
import { DatePicker as AntDatePicker } from '@src/helpers/Formik/formikAntdCompat'

export const StyledDatePicker: any = styled(AntDatePicker)`
  width: 100%;
`
